import { useEffect, useState } from "react";
import IconsEnum from "../../../../classes/enums/IconsEnum";
import IconButton from "../../../../components/iconButton/IconButton";
import CloseButton from "../../../../components/closeButton/CloseButton";
import LoadingOverlay from "../../../../components/loadingBar/LoadingOverlay";
import { TooltipOrientation } from "../../../../components/tooltip/Tooltip";
import { useKeyboardActivation } from "../../../../hooks/useKeyboardActivation";

import "./ModalBase.css";

const ModalBase = ({
  title,
  subtitle,
  children,
  onClose,
  tooltipClose = "Close",
  showGoBack = false,
  onGoBack,
  tooltipGoBack = "Go Back",
  isLoading = false,
  progress = 0,
  progressMessage = "",
  className = "",
}) => {
  const [showLoading, setShowLoading] = useState(isLoading);

  const goBackKeyDownHandler = useKeyboardActivation(onGoBack);

  useEffect(() => {
    setShowLoading(isLoading);

    if (isLoading && progress >= 100) {
      const timer = setTimeout(() => {
        setShowLoading(false);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [isLoading, progress]);

  return (
    <div className={`modal-base ${className}`}>
      <CloseButton
        onClose={onClose}
        tooltip={tooltipClose}
        disabled={showLoading}
      />
      {showGoBack && (
        <div
          role="button"
          tabIndex={0}
          onKeyDown={goBackKeyDownHandler}
          className="modal-back-button-container"
        >
          <IconButton
            icon={IconsEnum.GOBACK}
            onClick={onGoBack}
            noBgColor={true}
            className="close-button"
            disabled={showLoading}
            title={tooltipGoBack}
            tooltipOrientation={TooltipOrientation.Bottom}
          />
        </div>
      )}

      <LoadingOverlay
        isVisible={showLoading}
        progress={progress}
        message={progressMessage}
      />

      <div className="modal-column">
        {title && <div className="modal-title">{title}</div>}
        {subtitle && <div className="modal-subtitle">{subtitle}</div>}
        {children}
      </div>
    </div>
  );
};

export default ModalBase;
